import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { notNil } from '@robocorp/robocloud-shared-utils';
import { useWorkerGroupLinkKeysQuery } from '~/queries';
import { ApiHelperSelectInput, ApiHelperSelectInputWrapperProps } from './ApiHelperSelectInput';

export const SelectEnvironmentGroupLinkToken: FC<ApiHelperSelectInputWrapperProps> = ({
  value,
  setValue,
  pathParameters,
  ...props
}) => {
  const { t } = useTranslation();

  const { data: workerGroupLinkKeys = [], isInitialLoading: isLoadingWorkerGroupLinkKeys } =
    useWorkerGroupLinkKeysQuery(pathParameters.worker_group_id, {
      enabled: notNil(pathParameters.worker_group_id),
    });

  const environmentGroupLinkKeysItems = useMemo(
    () =>
      Object.entries(workerGroupLinkKeys).map(([id, environmentGroupLinkKey]) => {
        return {
          label: environmentGroupLinkKey.name as string,
          value: id,
        };
      }),
    [workerGroupLinkKeys],
  );

  return (
    <ApiHelperSelectInput
      label={t('workerApi.chooseWorkerGroupLinkToken')}
      items={environmentGroupLinkKeysItems}
      onChange={(value) => setValue('link_token_id', value)}
      loading={isLoadingWorkerGroupLinkKeys}
      value={value}
      noItemsFound={t('workerApi.noWorkerGroupLinkTokens')}
      {...props}
    />
  );
};
